import { schemaOrgPersons } from "@/helpers/schemaOrg/person";
import { Answer, Person, Question } from "schema-dts";

export const getSchemaAnswer = (props: { text: Answer["text"] }): Answer => {
  return {
    "@type": "Answer",
    text: props.text,
  };
};

export const getSchemaQuestion = (props: {
  name: Question["name"];
  acceptedAnswer: Answer;
  answerCount?: Question["answerCount"];
  datePublished?: Question["datePublished"];
  author?: Question["author"];
}): Question => {
  const question: Question = {
    "@type": "Question",
    name: props.name,
    answerCount: props.answerCount ? props.answerCount : 1,
    acceptedAnswer: props.acceptedAnswer,
  };

  if (props.datePublished) {
    question.datePublished = props.datePublished;
  }

  question.author = props.author || schemaOrgPersons.ScherbarthHubertus;

  return question;
};

export const getSchemaAuthor = (props: {
  name: string;
  url: string;
}): Person => {
  return {
    "@type": "Person",
    name: props.name,
    url: props.url,
  };
};
